import { useEffect, useState } from 'react';
import Aside from 'components/aside';
import { Header } from 'components/header';
import { useSearchParams } from 'react-router-dom';
import { useStore } from 'store';
import { RenderIf } from 'utilities/helpers';
import styles from './index.module.css';
import { client } from 'utilities/db';
import { AccessDenied } from 'components/acess-denied';
import { isValidCountryCode } from 'utilities/constants/countryConfig';

export const MainLayout = ({ children }) => {
  const {
    setUser,
    setBranch,
    setBrand,
    setBuisnessId,
    isWebMenu,
    setToken,
    user
  } = useStore((state) => state);

  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const getTokenDetails = async (userId, branchId, userEmail) => {
    setLoading(true);
    const response = (
      await client.post('/user/signInViaIDandEmail', {
        email: userEmail,
        id: +userId,
        branch_id: +branchId
      })
    )?.data;
    console.log('data a gya bhai a gya :', response);
    setUser(response?.user);
    setBrand(response?.user?.brand);

    console.log('response?.user?.branches', response?.user?.branches);
    if (response?.user?.branches?.length > 0) {
      const selectedBranch = response?.user?.branches?.find(
        (branch) => branch?.id === +branchId
      );
      setBranch(selectedBranch);
    } else {
      setBranch(response?.user?.branches?.[0]);
    }

    setBuisnessId(response?.user?.business?.id);
    setToken(response?.token);
    // Clear all search parameters from URL
    setSearchParams('');
    setLoading(false);
  };

  useEffect(() => {
    if (
      searchParams?.get('userId') &&
      searchParams?.get('branchId') &&
      searchParams?.get('user_email')
    ) {
      // Save country parameter to localStorage if present
      const countryParam = searchParams.get('country');
      if (countryParam && isValidCountryCode(countryParam.toUpperCase())) {
        try {
          localStorage.setItem('selectedCountry', countryParam.toUpperCase());
        } catch (error) {
          console.warn('Error saving country to localStorage:', error);
        }
      }
      
      getTokenDetails(
        searchParams?.get('userId'),
        searchParams?.get('branchId'),
        searchParams?.get('user_email')
      );
    }
  }, [searchParams]);

  const branchPermission = user?.role?.permissions?.find(
    (permission) => permission?.module_slug === 'branches'
  );

  return (
    <>
      {/* <RenderIf isTrue={!branchPermission?.access?.read}>
        <AccessDenied />
      </RenderIf> */}

      <RenderIf
        isTrue={!loading}
        //  && branchPermission?.access?.read}
      >
        <Header />
        <main className={styles.main}>
          <article
            className={
              !isWebMenu
                ? `${styles.article} ${styles.articleSmart}`
                : styles.article
            }
          >
            <div>
              <Aside userRole={`SUPER_ADMIN`} />
            </div>
            <div>
              <div className={`contain-bx`}>{children}</div>
            </div>
          </article>
        </main>
      </RenderIf>
    </>
  );
};
